module.exports = __webpack_public_path__ + "img/pattern.72e67c3c.png";